import type { Asset } from '../../firebase/common/feed';
import MarkdownEditor from './EditorWrapper.svelte';

export const preprocessBody = (body: string, images: Asset[]) => {
  for (const image of images) {
    if (!image.keyPath) {
      continue;
    }

    body = body.replaceAll(`private://${image.keyPath.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}`, image.url);
  }

  return body;
};

export default MarkdownEditor;
